module.exports = __webpack_public_path__ + "brandon_reg_it-webfont.9fc5f7eb22b3cf1a2c6d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_reg_it-webfont.woff2
// module id = 950
// module chunks = 7